import { AbstractProjectModel } from "@app/catalog-common";

export class ProjectUpdatedMessage {
    public project: AbstractProjectModel;
    
    constructor(project: AbstractProjectModel)
    {
        this.project = project;
    }
}